import * as React from "react"
import gsap from 'gsap'

class Cursor extends React.Component {
  componentDidMount() {
    this.cursorFollow();   
  }
  cursorFollow() {
    var cursor = document.querySelector('.floating--cursor');
    var posX = 0,
    posY = 0,
    mouseX = 0,
    mouseY = 0;
    gsap.to({}, 0.016, {
      repeat: -1,
      onRepeat: function() {
        posX += (mouseX - posX) / 9;
        posY += (mouseY - posY) / 9;

        gsap.set(cursor, {
            css: {
            left: posX - 12,
            top: posY - 12
            }
        });
      }
    });

    document.addEventListener("mousemove", function(e) {
      mouseX = e.clientX;
      mouseY = e.clientY;
    });

  }
  render() {
    return (
      <div className='floating--cursor'>Contact Us</div> 
    ) 
  }
}
export default Cursor
